<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form ref="factureForm" @submit="addFacture" :validation-schema="factureSchema">
        <div class="row">

          <div class="col-md-4">
            <div class="form-group mb-8 mb-sm-10 mb-md-15">
              <label class="d-block text-black fw-semibold mb-5">
                Date facture <span class="text-danger">*</span>
              </label>
              <Field name="date_facture" type="date" :value="date_facture"
                class="form-control shadow-none fs-md-15 text-black" contratholder="Entrer la date de facture" />
              <ErrorMessage name="date_facture" class="text-danger" />
            </div>
          </div>
          
          <div class="col-md-6">
            <div class="form-group mb-8 mb-sm-10 mb-md-15">
              <label class="d-block text-black fw-semibold mb-5">
                Service<span class="text-danger">*</span>
                </label>
                <Field name="service" type="text" v-slot="{ field }">
                <Multiselect v-model="field.value" v-bind="field" :options="serviceOptions" :preserve-search="true"
                   :multiple="false" :searchable="true" placeholder="Sélectionner le service"
                  label="label" track-by="label" />
                </Field>
                <ErrorMessage name="service" class="text-danger" />
              </div>
            </div>


          <div class="col-md-4">
            <div class="form-group mb-8 mb-sm-10 mb-md-15">
              <label class="d-block text-black fw-semibold mb-5">
                Montant facture <span class="text-danger">*</span>
              </label>
              <Field name="montant_facture" v-model="montant_facture" type="number" :disabled="true"
                class="form-control shadow-none fs-md-15 text-black" contratholder="Entrer le montant" />
              <ErrorMessage name="montant_facture" class="text-danger" />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-8 mb-sm-10 mb-md-15">
              <label class="d-block text-black mb-10">
                Mois
                <span class="text-danger">*</span>
              </label>
              <Field name="mois" v-model="mois" type="text" v-slot="{ field }">
                <Multiselect :searchable="true" :options="[
                  { value: 0, label: 'Janvier' },
                  { value: 1, label: 'Février' },
                  { value: 2, label: 'Mars' },
                  { value: 3, label: 'Avril' },
                  { value: 4, label: 'Mai' },
                  { value: 5, label: 'Juin' },
                  { value: 6, label: 'Juillet' },
                  { value: 7, label: 'Aout' },
                  { value: 8, label: 'Septembre' },
                  { value: 9, label: 'Octobre' },
                  { value: 10, label: 'Novembre' },
                  { value: 11, label: 'Decembre' },
                ]" v-model="field.value" v-bind="field" contratholder="Sélectionner le mois" />
              </Field>
              <ErrorMessage name="mois" class="text-danger" />
            </div>
          </div>


          <div class="col-md-6">
            <div class="form-group mb-8 mb-sm-10 mb-md-15">
              <label class="d-block text-black mb-10">
                Année
                <span class="text-danger">*</span>
              </label>
              <Field name="annee" v-slot="{ field }">
                <Multiselect :options="years" :searchable="true" v-model="field.value" v-bind="field"
                  contratholder="Sélectionner une année" />
              </Field>
              <ErrorMessage name="annee" class="text-danger" />
            </div>
          </div>

          

          <div class="col-md-12 mt-3">
            <div class="d-flex align-items-center ">
              <button v-if="checkPermission('AddContrat')" class="btn btn-success me-3" v-show="!auclic" type="submit">
                Enregistrer
              </button>
              <button class="btn btn-success me-3" v-show="!auclic" @click="normalise" type="submit">
                Normaliser
              </button>
              <button class="btn btn-success" type="button" v-show="auclic" disabled>
                <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                <span class="visually-hidden">Loading...</span>
              </button>
              <router-link to="/liste-facture" class="btn btn-danger"><i
                  class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Annuler</router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>
<script lang="ts">

import { defineComponent, onMounted, ref, watch } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import ApiService from '@/services/ApiService';
import { error, success } from '@/utils/utils';
import { useRouter } from 'vue-router';
import Multiselect from '@vueform/multiselect';
import axios from 'axios';
import JwtService from "@/services/JwtService";


export default defineComponent({
  name: "AddFacture",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect
  },
  setup: () => {
    const factureSchema = Yup.object().shape({
      service: Yup.string().required("Service est obligatoire."),
      date_facture: Yup.string().required("Date facture est obligatoire."),
      montant_facture: Yup.string().required("Montant est obligatoire."),
      //reference: Yup.string().required("Reference est obligatoire."),
      contrat: Yup.string().required("Contrat est obligatoire."),
      mois: Yup.string().required("Mois est obligatoire."),
      annee: Yup.string().required("Année est obligatoire."),
    });

    const contrats = ref();
    const normaliser = ref(false);
    const contratOptions = ref([]);
    const serviceOptions = ref([]);
    const factureForm = ref(null);
    const montant_facture = ref();
    const reference = ref();
    const contrat = ref();
    const auclic = ref(false)
    const date_facture = ref(new Date().toISOString().slice(0, 10));
    //const contratOptions = ref();
    const router = useRouter();
    const currentYear = new Date().getFullYear();
    const minPeriode = ref(`${currentYear}-01`);
    const year = ref(new Date().getFullYear());
    const years = ref(
      Array.from({ length: 2 }, (_, i) => {
        const year = new Date().getFullYear();
        return { value: year + i, label: year + i };
      })
    );

    onMounted(() => {
      getAllServices();
    });

    const normalise = () => {
      normaliser.value = true;
    }
    const addFacture = async (values, { resetForm }) => {
      auclic.value = true;
      values["normalise"] = normaliser.value;
      console.log("VALUES ==> ", values)
      ApiService.post("/factures", values)
        .then(({ data }) => {
          if (data.code == 201) {
            normaliser.value = false;
            success(data.message);
            auclic.value = false;
            resetForm();
            router.push({ name: "ListeFacturePage" });
          }
        }).catch(({ response }) => {
          normaliser.value = false;
          auclic.value = false;
          error(response.data.message);
        });
    };

    const noOptionsTextAbb = ref("Tapez au moins trois caractères");
    const nooptions = "Aucun enregistrement trouvé";
    const noResultText = "Aucun enregistrement trouvé";

    const contratSelect = async (value) => {
      const contrat = await axios.get(`/contrats/${value}`);
      const contratD = contrat.data.data;
      const contratData = contrat.data.data.contratElements;
      var som = parseFloat(contratD.loyer);
      contratData.forEach(element => {
        som += element.prix * element.quantite;
      });

      montant_facture.value = som;
      console.log(contrat.data.data, "contrat")
      console.log(value, "contrat")
    };

    const fetchContrats = async (key) => {
      try {
        const response = await axios.get(`/contrats/recherche/${key}`);
        const contratsData = response.data.data;
        console.log(response)
        console.log('ABONNEMENT == > ', contratsData);
        contratOptions.value = contratsData.map((contrat) => (
          {
            value: `${contrat.id}`,
            label: `${contrat.reference} - ${contrat?.codePlace}-[${contrat.nomMarchand}]`,
          }));
        console.log(contratOptions.value, "rrrrrrrrrrrrrr")
        if (contratOptions.value.length == 0) {
          noOptionsTextAbb.value = noResultText;
        } else {
          noOptionsTextAbb.value = 'Tapez au moins trois caractères';
        }
        return contratOptions.value;
      } catch (error) {
        //
      }
    }


    const getAllServices = async () => {
          try{
          const response = await ApiService.get('/all/services');
          const servicesData = response.data.data.data;
          console.log('Data', servicesData)
          serviceOptions.value = servicesData.map((service) => ({
            value: service.id,
            label: service.libelle,
          }));
          }
          catch(error){
            //error(response.data.message)
          }
        }
    
    const checkPermission = (name) => {
      return privileges.value.includes(name);
    };

    const privileges = ref<Array<string>>(JwtService.getPrivilege());


    return {
      normalise,
      factureSchema,
      addFacture,
      auclic,
      factureForm,
      contratOptions,
      contrat,
      years,
      minPeriode,
      montant_facture,
      fetchContrats,
      contrats,
      nooptions,
      noOptionsTextAbb,
      date_facture,
      contratSelect,
      checkPermission,
      serviceOptions
    };
  },
});
</script>
